import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=0b71f87b&scoped=true&"
import script from "./CouponModal.vue?vue&type=script&lang=js&"
export * from "./CouponModal.vue?vue&type=script&lang=js&"
import style0 from "./CouponModal.vue?vue&type=style&index=0&id=0b71f87b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71f87b",
  null
  
)

export default component.exports